import { jsx } from "react/jsx-runtime";
import { useAddressLabel } from "../../../hooks/use-address-label.js";
import { useAddressAutofill } from "../../multiline-address/multiline-address/address-autofill-context.js";
import { AddressInputWUT } from "../../../ui/address-input/address-input-wut.js";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const MlaAddressLineWUT = ({
  autocomplete,
  ...rest
}) => {
  const fieldType = FIELD_TYPES.MLA_ADDRESS_LINE;
  const { autocompleteEnabled } = useAddressAutofill();
  const label = useAddressLabel("addressLine1");
  return autocomplete || autocompleteEnabled ? /* @__PURE__ */ jsx(AddressInputWUT, { ...rest, fieldType, label }) : /* @__PURE__ */ jsx(TextInputFieldWUT, { ...rest, fieldType, label });
};
export {
  MlaAddressLineWUT
};
//# sourceMappingURL=mla-address-line-wut.js.map
